/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAEjectIcon24Solid = forwardRef('MediaUiAEjectIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "m4.37 12.391 6.388-7.863a1.6 1.6 0 0 1 2.484 0l6.388 7.863c.85 1.046.106 2.609-1.242 2.609H5.612c-1.348 0-2.092-1.563-1.242-2.609Z" }),
        React.createElement("path", { d: "M5.5 17a1.5 1.5 0 1 0 0 3h13a1.5 1.5 0 0 0 0-3h-13Z" })));
});
